import { Input, Typography } from "@stardust-ds/react"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { useEffect, useContext, useState } from "react"
import intl from "react-intl-universal"

import Button from "../../atoms/Button"
import Modal from "../../molecules/Modal"
import styles from "./index.module.scss"
import useCheckSubmitRegister from "../../../hooks/useCheckSubmitRegister"
import PaineisContext from "../../../contexts/Paineis"
import BoardContext from "../../../contexts/Board"

export default function RcmpModalAddBlock(props) {
  const {
    bIsOpen,
    cTitle,
    fnOnClose,
    fnHandleConfirm,
    bIsEdit,
    fnSetBisEdit,
    fnHandleSubmitEdit,
    cPrevData,
    oBlockRes,
    oBlock,
  } = props

  const { oCurrentPanel } = useContext(PaineisContext)
  const { oCurrentBoard } = useContext(BoardContext)
  const [bIsSubmit, fnBisSubmit] = useState(false)

  const [fnCheckRegister, bLoadingRegister] = useCheckSubmitRegister()

  const schema = yup.object().shape({
    name: yup.string().required(intl.get("form.required_field")),
  })

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: yupResolver(schema),
  })

  async function fnCheckBlockAndBoard() {
    const oCheckRegister = {
      nBlockId: bIsEdit ? oBlock?.opbl_nid : null,
      nBoardId: oCurrentBoard?.id,
      nPanelId: oCurrentPanel?.id,
    }

    const cErrorMessage = bIsEdit
      ? intl.get("BlocksPage.update_block_error")
      : intl.get("BlocksPage.create_block_error")
    return await fnCheckRegister(oCheckRegister, cErrorMessage)
  }

  async function fnSubmitNewBlock(data) {
    fnBisSubmit(true)
    const bCanSubmit = await fnCheckBlockAndBoard()
    if (!bCanSubmit) {
      fnCancelCriation()
      return
    }

    if (bIsEdit) {
      await fnHandleSubmitEdit(data)
      fnSetBisEdit(false)
      reset({
        name: "",
      })
    }
    if (!bIsEdit) {
      await fnHandleConfirm(data)
      reset({
        name: "",
      })
    }
  }

  useEffect(() => {
    if (!bIsEdit) return
    setValue("name", cPrevData)
  }, [cPrevData, bIsEdit])

  useEffect(() => {
    fnBisSubmit(false)
  }, [bIsOpen])

  function fnCancelCriation() {
    if (bSubmitLoading) return

    if (bIsEdit) {
      fnOnClose(false)
      fnSetBisEdit(false)
      reset({
        name: "",
      })
    }
    if (!bIsEdit) {
      fnOnClose(false)
      fnSetBisEdit(false)
      reset({
        name: "",
      })
    }
  }

  const cSaveButtonText = bIsEdit
    ? intl.get("save_changes")
    : intl.get("BlocksPage.add_block")
  const bSubmitLoading = oBlockRes.loading || bLoadingRegister

  return (
    <Modal isOpen={bIsOpen} size={"lg"}>
      <Modal.Header onClose={fnCancelCriation}>{cTitle}</Modal.Header>
      <form className={styles.container} onSubmit={handleSubmit(fnSubmitNewBlock)}>
        <Modal.Content>
          <div className={styles.contentContainer}>
            <Input
              autoComplete="off"
              type={"text"}
              isRequired
              isFullWidth
              label={`${intl.get("BlocksPage.block_name")} *`}
              placeholder={intl.get("BlocksPage.block_name_placeholder")}
              {...register("name")}
            />
            <Typography color="#FF3541" type="p3">
              {errors.name?.message}
            </Typography>
          </div>
        </Modal.Content>
        <Modal.Footer>
          <div className={styles.buttonContainer}>
            <Button
              onClick={fnCancelCriation}
              variant="outline"
              type="button"
              disabled={bSubmitLoading}
            >
              {intl.get("cancel")}
            </Button>
            <Button
              variant="primary"
              type="submit"
              isLoading={bSubmitLoading || bIsSubmit}
              disabled={bIsSubmit}
            >
              {cSaveButtonText}
            </Button>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
